export default __webpack_public_path__ + "static/media/over50k_result_graphic.2dd29c38.svg";